<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Planning</h2>

                <form method="post" @submit.prevent="onSubmit">

                    <div class="alert alert-danger" v-if="error" v-text="error"></div>
                    <div class="alert alert-success" v-if="success" v-text="success"></div>

                    <ScheduleCreator v-model="schedule" :startDate="startDate" @removeInspection="onRemoveInspection"></ScheduleCreator>

                    <input type="submit" value="Planning opslaan" class="btn btn-primary mt-2">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
	import { CREATE_SCHEDULE, DELETE_SCHEDULE } from '@/store/modules/schedule'
	import ScheduleCreator from '@/components/global/ScheduleCreator'

	export default {
		props: ['object', 'startDate'],

		components: { ScheduleCreator },

		data () {
			return {
				isLoading: false,
				error: null,
				success: null,
				schedule: [],
			}
		},

		methods: {
			handleClosePopup () {
				this.$emit('togglePopup')
			},

			onSubmit () {
				this.isLoading = true

				this.$store.dispatch(CREATE_SCHEDULE, {
					object: this.object.id,
					data: {
						data: this.schedule,
					},
				}).then(() => {
					this.isLoading = false
					this.$emit('togglePopup')
				}).catch(() => {
					this.isLoading = false
				})
			},

			onRemoveInspection (inspection) {
				if (inspection.id) {
					this.$store.dispatch(DELETE_SCHEDULE, {
						object: this.object.id,
						inspection: inspection.id,
					}).then((response) => {
						console.log(response)
					}).catch((response) => {
						console.log(response)
					})
				}
			},
		},

		mounted () {
			this.schedule = this.object.schedule
		},

		computed: {},
	}
</script>

<style lang="scss" scoped>
    .popup-content {
        min-height: 90vh !important;
    }
</style>